var initTabPanel = (container) => {
    try {
      let tabControls = container.querySelector(".js-tab-controls");
      let tabContents = container.querySelector(".js-tab-contents");
      
      Array.from(tabControls.children).forEach((item) => {
        let target = tabContents.querySelector(item.dataset.target);
        
        item.addEventListener("click", () => {
          if (item.classList.contains("active")) {
            return;
          }
          
          Array.from(tabControls.children).forEach((control) => {
            control.classList.remove("active");
          });
          
          Array.from(tabContents.children).forEach((content) => {
            content.classList.remove("active");
          });
          
          item.classList.add("active");
          target.classList.add("active");
        });
      });
    } catch (error) {
      console.warn("Error in Tab Panel function:", error);
      console.log(container);
    }
  };